

// 合并所有reducer 并且返回
import { combineReducers } from 'redux'
import { user } from './redux/user.redux'
import { chatuser } from './redux/chatuser.redux'
import { message } from './redux/message.redux.js'
import { newGame } from './redux/newGame.redux.js'
export default combineReducers({user,chatuser,message,newGame})




// WEBPACK FOOTER //
// ./src/reducer.js